var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "08922D68-2243-4C8E-8E2E-1B0E7A26365E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car-insurance---13---View-details--1",
    transform: "translate(-268.000000, -748.000000)",
    fill: "#202020",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(223.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(30.000000, 648.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-info-1228105",
    transform: "translate(15.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,20 C15.5230159,20 20,15.5230159 20,10 C20,4.47698413 15.5230159,0 10,0 C4.47698413,0 0,4.47698413 0,10 C0,15.5230159 4.47698413,20 10,20 Z M10.5555556,3.5 C11.4761508,3.5 12.2222222,4.24623016 12.2222222,5.16666667 C12.2222222,6.08710317 11.4761508,6.83333333 10.5555556,6.83333333 C9.63496032,6.83333333 8.88888889,6.08710317 8.88888889,5.16666667 C8.88888889,4.24623016 9.63496032,3.5 10.5555556,3.5 Z M10,7.61111111 C11.6666667,7.61111111 12.0709524,8.59448413 11.884127,9.80761905 L11.1111111,14.8334127 C11.1111111,14.8334127 11.6666667,14.8334127 12.7777778,14.2778571 C12.7777778,14.2778571 12.2222222,16.5000794 10,16.5000794 C8.33333333,16.5000794 7.92904762,15.5167063 8.11587302,14.3035714 L8.88888889,9.27777778 C8.88888889,9.27777778 8.33333333,9.27777778 7.22222222,9.83333333 C7.22222222,9.83333333 7.77777778,7.61111111 10,7.61111111 L10,7.61111111 Z",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.80d467857b463d047e1cbd7b4121f078.svg";
export { ForwardRef as ReactComponent };